// import 'antd/dist/antd.css';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd'; // Import Icon from antd
import { FacebookOutlined, InstagramOutlined, XOutlined } from '@ant-design/icons'; // Import icons from ant-design/icons
import './style.css';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const ResponsiveHeader = () => {
    // const [viewportWidth, setViewportWidth] = useState(0);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;   

    // Function to save viewport dimensions
    // const saveViewportDimensions = throttle(() => {
    //     setViewportWidth(window.innerWidth);
    // }, applyViewportChange);

    // Effect hook to handle component mount and unmount
    // useEffect(() => {
    //     saveViewportDimensions(); // Call initially
    //     window.addEventListener('resize', saveViewportDimensions); // Add resize event listener

    //     return () => {
    //         window.removeEventListener('resize', saveViewportDimensions); // Cleanup event listener on unmount
    //     };
    // }, [applyViewportChange]);

    // Render for larger screens
    // if (viewportWidth > mobileBreakPoint) {
    return (
        <div>
            <Row
                type="flex"
                justify="center"
                style={{
                    background: 'linear-gradient(130.75deg, #97A8FE 5.78%, #C682FC 98.3%), #C4C4C4',
                    // height: '200px',
                    color: '#fff',
                }}
            >
                <Col span={24}>
                    <Row type="flex" justify="center" align="top" style={{ marginTop: '25px', marginBottom: '4px' }}>
                        <Col span={1}>&nbsp;</Col>
                        <Col span={5}>
                            <div style={{ fontFamily: 'Roboto', fontSize: 14, marginBottom: 15 }}>
                                <strong>{langdata.ContactUs ? langdata.ContactUs : 'Contact Us'}</strong>
                            </div>
                            <div style={{ fontFamily: 'Roboto', marginBottom: 15 }}>
                  QuikDr Healthcare Pvt. Ltd
                                <br />
                  Near Overbridge,
                                <br />
                  Thiruvananthapuram , Kerala, 695036
                                <br />
                  Phone : +91 7012030327
                                <br />
                  Support Time : Monday to Saturday
                                <br />
                  10:00 AM to 5:00 PM (IST)
                            </div>
                        </Col>
                        <Col span={1}>&nbsp;</Col>
                        <Col span={5}>
                            <div style={{ fontFamily: 'Roboto' }}>
                                <div style={{ fontFamily: 'Roboto', marginBottom: 15 }}>
                                    <strong>{langdata.AreyouarunningLab ? langdata.AreyouarunningLab : 'Are you a running Lab ?'}</strong>
                                </div>
                                <div style={{ fontFamily: 'Roboto', fontSize: 14 }}>
                                    <a
                                        href="https://forms.gle/x9bomy8PzMmpRpwm8"
                                        target="_blank"
                                        style={{ color: '#ffffff' }} rel="noreferrer"
                                    >
                                        {langdata.Listyourlabnow ? langdata.Listyourlabnow : 'List your lab now'}
                                    </a>
                                </div>
                            </div>
                        </Col>
                        <Col span={1}>&nbsp;</Col>
                        <Col span={5}>
                            <div style={{ fontFamily: 'Roboto', fontSize: 14, marginBottom: 15 }}>
                                <strong>{langdata.AreyouaHospital ? langdata.AreyouaHospital : 'Are you a Hospital ?'}</strong>
                            </div>
                            <div style={{ fontFamily: 'Roboto' }}>
                                <a
                                    href="https://forms.gle/x9bomy8PzMmpRpwm8"
                                    target="_blank"
                                    style={{ color: '#ffffff' }} rel="noreferrer"
                                >
                                    {langdata.Listyourhospitalnow ? langdata.Listyourhospitalnow : 'List your hospital now'}
                                </a>
                            </div>
                        </Col>
                        <Col span={1}>&nbsp;</Col>
                        <Col span={5}>
                            <div style={{ fontFamily: 'Roboto', fontSize: 14, marginBottom: 15 }}>
                                <strong>{langdata.FollowUs ? langdata.FollowUs : 'Follow Us'}</strong>
                            </div>
                            <div>
                                <a href="https://www.facebook.com/quikdoctor" target="_blank" style={{ color: 'inherit' }} rel="noreferrer">
                                    <FacebookOutlined style={{ fontSize: 25, marginBottom: 10 }} />
                                </a>
                                <a href="https://twitter.com/quikdr" target="_blank" style={{ color: 'inherit' }} rel="noreferrer">
                                    <XOutlined style={{ fontSize: 25, marginBottom: 10, marginLeft: 10 }} />
                                </a>
                                <a href="https://www.instagram.com/quikdr/?hl=en" target="_blank" style={{ color: 'inherit' }} rel="noreferrer">
                                    <InstagramOutlined style={{ fontSize: 25, marginBottom: 10, marginLeft: 10 }} />
                                </a>
                            </div>
                        </Col>
                        {/* <Col xl={{ span: 0 }} lg={{ span: 0 }} md={{ span: 0 }} xs={{ span: 24 }}>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontFamily: 'Roboto', fontSize: 14 }}>QuikDr.</div>
                            </div>
                        </Col> */}
                    </Row>
                </Col>
            </Row>
            <Row
                type="flex"
                justify="center"
                style={{
                    background: 'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4',
                    color: '#fff',
                    height: '50px',
                }}
            >
                <Col span={24} style={{ textAlign: 'right', marginTop: '15px' }}>
                    <span style={{ marginRight: '30px', fontSize: '15px' }}>
                        <a
                            href="https://quikdr.com/healthtips/privacy-policy-quikdr-health-tips/"
                            target="_blank"
                            style={{ color: 'inherit' }} rel="noreferrer"
                        >
                            <span style={{ marginBottom: 8 }}>{langdata.Privacypolicy ? langdata.Privacypolicy : 'Privacy policy'}</span>
                        </a>
                    </span>
                    <span style={{ marginRight: '30px', fontSize: '15px' }}>
                        <a
                            href="https://quikdr.com/healthtips/privacy-policy-quikdr-health-tips/"
                            target="_blank"
                            style={{ color: 'inherit' }} rel="noreferrer"
                        >
                            <span style={{ marginBottom: 8 }}>{langdata.Termsandcondition ? langdata.Termsandcondition : 'Terms and condition'}</span>
                        </a>
                    </span>
                </Col>
            </Row>
        </div>
    );
    // }

    // Render for smaller screens
    // return (
    //     <div>
    //         <Row
    //             type="flex"
    //             justify="center"
    //             style={{
    //                 background: 'linear-gradient(129.32deg, #546FFB 5.78%, #AD4DF8 98.3%), #C4C4C4',
    //                 color: '#fff',
    //                 height: '50px',
    //                 paddingTop: '15px',
    //             }}
    //         >
    //     QuikDr Healthcare Private Limited
    //         </Row>
    //     </div>
    // );
};

ResponsiveHeader.propTypes = {
    mobileBreakPoint: PropTypes.number,
    applyViewportChange: PropTypes.number,
};

ResponsiveHeader.defaultProps = {
    mobileBreakPoint: 772,
    applyViewportChange: 250,
};

export default connect(
    null,
    null
)(ResponsiveHeader);
